import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Admin from "./Admin";
import Book from "./Book";
import Food from "./Food";
import Account from "./Account";
import Addons from "./Addons";
import Franchise from "./Franchise";
import ListProperty from "./ListProperty";
import Experience from "./Experience";
import Experiences from "./Experiences";
import Package from "./Package";
import Packages from "./Packages";
import Locations from "./Locations";
import About from "./About";
import Contact from "./Contact";
import FreeWifi from "./FreeWifi";
import WifiAdmin from "./WifiAdmin";


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<Book />} />
        <Route path="/food" element={<Food />} />
        <Route path="/addons" element={<Addons />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/account" element={<Account />} />
        <Route path="/franchise" element={<Franchise />} />
        <Route path="/list-property" element={<ListProperty />} />
        <Route path="/experience/:slug" element={<Experience />} />
        <Route path="/experiences" element={<Experiences />} />
        <Route path="/package/:slug" element={<Package />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/freewifi" element={<FreeWifi />} />
        <Route path="/wifi-admin" element={<WifiAdmin />} />
      </Routes>
    </BrowserRouter>
  );
}
